import React from 'react'

const generateContextProvider = function <Type>(
    value?: (() => Type) | Type,
    ProviderWrapper?: React.FC<{
        provider: React.FC<{value: Type; children: React.ReactNode}>
        children: React.ReactNode
    }>
) {
    //create the context
    const context = React.createContext<Type | undefined>(undefined)

    //get the useContext hook
    const useContext = () => {
        const contextInstance = React.useContext(context)
        if (contextInstance === undefined) {
            throw new Error('useContext must be used within a ContextProvider')
        }
        return contextInstance
    }
    const useContextOptional = () => {
        const contextInstance = React.useContext(context)
        return contextInstance
    }

    //get the provider
    let newValue: Type | undefined
    if (typeof value == 'function') newValue = (value as () => Type)()
    else newValue = value
    const EqxContextProvider = (props: {children: React.ReactNode; value?: (() => Type) | Type}) => {
        const ContextProvider = context.Provider
        let value: Type | undefined = newValue
        if (props.value) {
            if (typeof props.value == 'function') value = (props.value as () => Type)()
            else value = props.value
        }
        return <ContextProvider value={value}>{props.children}</ContextProvider>
    }
    if (ProviderWrapper) {
        const Provider = (props: {children: React.ReactNode}) => (
            <ProviderWrapper provider={EqxContextProvider} children={props.children} />
        )
        return {ContextProvider: Provider, useContext, useContextOptional}
    }

    //provider wrapper props

    return {ContextProvider: EqxContextProvider, useContext, useContextOptional}
}

type ContextProviderWrapperProps<Type> = {
    provider: React.FC<{value: Type; children: React.ReactNode}>
    children: React.ReactNode
    value?: Type
}

export {generateContextProvider as default, type ContextProviderWrapperProps}
